import React, { useState } from 'react';
import DistrictServices from '../../services/DistrictServices';

const DistrictStatus = ({state,page ,onSuccess}) => {

  const [isChecked, setIsChecked] = useState(state?.status === 'Active');

  const handleToggle = async () => {
    const newStatus = !isChecked ? 'Active' : 'Inactive';
    setIsChecked(!isChecked);
    if(page === 'district'){
      const res = await DistrictServices.updateStateStatus(state._id, {
        status: newStatus
      });

      onSuccess();
    }
  };

  return (
   
      <div className="check-box">
        <input
          type="checkbox"
          checked={isChecked}
          onChange={handleToggle}
        />
      </div>
    
  );
};

export default DistrictStatus;
